import { api, apiUrl } from "../../shared/services/service";
import type { AdminCertificatesKpisRequest, AdminCertificatesKpisResponse } from "../models/admin-kpis.models";
import axios from "axios";

export const getAdminCertificatesKpis = async (
  request: AdminCertificatesKpisRequest = {},
): Promise<AdminCertificatesKpisResponse> => {
  const params: Record<string, string> = {};
  if (request.environment) {
    params.environment = request.environment;
  }

  if (request.vesselTypes !== undefined) {
    params.vesselTypes = request.vesselTypes.join(",");
  }

  const response = await api.get(`${apiUrl}/admin/kpis/certificates`, {
    params: Object.keys(params).length > 0 ? params : undefined,
  });
  return response.data;
};

export const getAdminCertificatesKpisErrorMessage = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    const responseData = error.response?.data as { error?: string; message?: string } | string | undefined;

    if (typeof responseData === "string") {
      return responseData;
    }

    return responseData?.error ?? responseData?.message ?? error.message;
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "Certificates KPI request failed.";
};
